import Phaser from 'phaser';
import { GameBuilder } from '@pbl/digital-games-core/lib/core/builder/GameBuilder';
import { GridConfig } from '@pbl/digital-games-core/lib/core/builder/GridConfig';
import { CrosswordGame } from '@pbl/digital-games-core/lib/core/CrosswordGame';
import { Tile } from '@pbl/digital-games-core/lib/core/Tile';
import { CrosswordTileSprite } from './CrosswordTileSprite';
// @ts-ignore
import { CongratsMessageForPrizes } from './components/CongratsMessageForPrizes';
import { Button } from './components/Button';
import { AudioScene } from './AudioScene';
import { AlphaAction } from './actions/core/AlphaAction';
import { RotateAction } from './actions/core/RotateAction';
import { MoveAction } from './actions/core/MoveAction';
import { TweenSequenceAction } from './actions/core/TweenSequenceAction';
import { ScaleAction } from './actions/core/ScaleAction';
import { DisplaySizeAction } from './actions/core/DisplaySizeAction';
import { TileJumpAction } from './actions/custom/TileJumpAction';
import { TweenAction } from './actions/core/TweenAction';
import { CallFuncAction } from './actions/core/CallFuncAction';
// @ts-ignore
import { CongratsMessageForFun } from './components/CongratsMessageForFun';
import { MenuComponent } from './components/MenuComponent';
import { CongratsMessageForInstantWin } from './components/CongratsMessageForInstantWin';
import {GameOverMessage} from "./components/GameOverMessage";

enum TileState {
  Blank,
  Covered,
  Revealed,
  PatternRevealed
}

enum TileType {
  Call,
  Grid,
  InstantWin
}

export class CrosswordScene extends AudioScene {
  private CallTileSize = 63;
  private CallTileHorizontalOffset = 65;
  private CallTileVerticalOffset = 60;

  private GridTileSize = 63;
  private GridTileHorizontalOffset = 56;
  private GridTileVerticalOffset = 465;
  private GridBackgroundSize = 715;

  private InstantWinTileSize = 60;

  private revealGameBuilder: GameBuilder | undefined = undefined;
  private revealGame;

  private wordsMatchedLabel;
  private lettersToFindLabel;
  // @ts-ignore
  private youWonInstantMessage;

  private callSprites: CrosswordTileSprite[] = [];
  private gridSprites: CrosswordTileSprite[] = [];
  private instantWinSprints: CrosswordTileSprite[] = [];

  private gridSpritesCurrentlyAnimatingBlockedReveal: CrosswordTileSprite[] = [];
  private gridSpritesCurrentlyAnimatingWordReveal: CrosswordTileSprite[] = [];

  private music: Phaser.Sound.BaseSound | null = null;

  private hintClicked = false;
  private isAutoRevealing = false;
  // @ts-ignore
  private revealAllButton;
  private hintSequence: TweenSequenceAction | null = null;
  private hintSprite;
  private hintTile;

  private hitScoreParticles;
  // @ts-ignore
  private winningMessage;

  constructor() {
    super('CrosswordScene', 'CrosswordBCLC');
    this.revealGame = new CrosswordGame();
  }
  initBackground() {
    let backgroundClass = "background-";
    let pulse = '1';
    // @ts-ignore
    if (typeof PblInterface !== 'undefined') {
      // @ts-ignore
      pulse = PblInterface.game.config.pulse;
    } else {
      pulse = window._po_gm.config.pulse;
    }


    switch(pulse) {
      case '2':
        backgroundClass += '2';
        break;
      case '3':
        backgroundClass += '3';
        break;
      case '4':
        backgroundClass += '4';
        break;
      default:
        backgroundClass += '1';
    }
    document.body.classList.add(backgroundClass);
  }
  preload() {

  }

  create() {
    let gameFace;
    // @ts-ignore
    if (typeof PblInterface !== 'undefined') {
      // @ts-ignore
      gameFace = PblInterface.game.config;
      // @ts-ignore
      PblInterface.game.uiReady();

    } else {
      gameFace = window._po_gm.config;
    }
    this.isAutoRevealing = false;
    this.revealGame = new CrosswordGame();
      this.initBackground();
      this.revealGameBuilder = new GameBuilder(
        this.revealGame,
        // @ts-ignore
        new GridConfig(gameFace.callLetters, 2, {}, TileType.Call),
        // @ts-ignore
        [new GridConfig(gameFace.gridLetters, 11, { '#': TileState.Blank }, TileType.Grid)],
        // @ts-ignore
        new GridConfig("abcdefghijklmnopqrstuvwxyz", 1, {}, TileType.Call)
      );

      this.revealGameBuilder.buildStandardRevealGame();
      this.initAudioManager();
      this.initMusic();
      this.addBlackRectangle();
      this.playGameStartSound();
      this.addCallTitle(); // label
      this.addCallLetters();
      this.addGridBackground();
      this.addGridLetters();
      this.addMenu();

      this.addEventListeners();
      this.addCounterElements(); // word match label

      this.addHintButton();
      this.addRevealAllButton();
      this.addParticles();

      if (gameFace.gameType === "fun") {
        this.addFunGameLabel();
      }

  }

  initAudioManager() {
    const volume = this.gameSettingsManager.getSettingValue('volumne', '1') === '1';

    this.audioManager.setVolume(volume);

    this.audioManager.musicPlayed.subscribe(this, this.playMusic);
    this.audioManager.musicPaused.subscribe(this, this.pauseMusic);
    this.audioManager.soundEffectPlayed.subscribe(this, this.playSoundEffect);
    this.audioManager.volumeChanged.subscribe(this, this.volumeChange);
  }

  initMusic() {
    this.music = this.sound.add('bg-music-custom', {
      loop: true,
      delay: 3000,
      volume:this.audioManager.getBGVolume()
    });
  }

  addBlackRectangle() {
    const graphics = this.add.graphics();

    graphics.fillStyle(0x000000, 1);

    const x = 18;
    const y = 425;
    const width = 707;
    const height = 706;
    const radius = 10;

    graphics.fillRoundedRect(x, y, width, height, radius);
  }

  volumeChange() {
    // @ts-ignore
    this.music.setVolume(this.audioManager.getBGVolume());
  }

  playGameStartSound() {
    this.audioManager.playSoundEffect('game-setup');
    if (!this.audioManager.areSoundEffectsEnabled()) {
      this.audioManager.playMusic();
    }
  }

  playSoundEffect(name) {
    const sound = this.sound.add(name, { volume: this.audioManager.getSFXVolume() });
    const self = this;

    if (name === 'game-setup') {
      sound.once('complete', () => {
        self.audioManager.playMusic();
      });
    }

    sound.play();
  }

  playMusic() {
    if (this.music !== null) {
      if (this.music.isPaused) {
        this.music.resume();
      } else {
        this.music.play();
      }
    }
  }

  pauseMusic() {
    if (this.music !== null && this.music.isPlaying) {
      this.music.pause();
    }
  }

  addBranding() {
    const branding = this.add.sprite(375, -100, 'branding').setDisplaySize(300, 120);

    new MoveAction(this, branding, 1700, branding.x, 80)
      .setDelay(1500)
      .setEase('Bounce')
      .run();
  }

  addCallTitle() {
    const callTitle = this.add.image(375, -20, 'call-letters');
    new MoveAction(this, callTitle, 1700, callTitle.x, this.CallTileVerticalOffset)
      .setDelay(3000)
      .setEase('Bounce')
      .run();
  }


  addCounterElements() {
    const style = { color: '#333333', font: '45px sans-serif', align: 'center' };
    const wordsMatchedCaption = this.add.sprite(110, this.physics.world.bounds.height - 1000, 'words-matched').setDisplaySize(170, 71);
    const wordsMatchedBox = this.add
      .sprite(278, this.physics.world.bounds.height - 1000, 'scorebox')
      .setDisplaySize(166, 71)
      .setDepth(0);
    this.wordsMatchedLabel = this.add
      .text(278, this.physics.world.bounds.height - 1003, this.revealGame.getPatternsFound(), style)
      .setOrigin(0.5);

    const lettersToFindCaption = this.add.sprite(470, this.physics.world.bounds.height - 1000, 'letter-to-find').setDisplaySize(165, 71);
    const lettersToFindBox = this.add.sprite(635, this.physics.world.bounds.height - 1000, 'scorebox').setDisplaySize(166, 71);
    this.lettersToFindLabel = this.add
      .text(635, this.physics.world.bounds.height - 1003, this.revealGame.getGridTilesToReveal(), style)
      .setOrigin(0.5);

    const elementsToAnimate = [
      wordsMatchedCaption,
      wordsMatchedBox,
      this.wordsMatchedLabel,
      lettersToFindCaption,
      lettersToFindBox,
      this.lettersToFindLabel
    ];
    const animationDelays = [100, 200, 200, 150, 250, 250];

    let i = 0;
    for (const element of elementsToAnimate) {
      new ScaleAction(this, element, 350, element.scaleX, element.scaleY)
        .setDelay(3000 + animationDelays[i])
        .setEase('Power2')
        .run();
      element.setScale(0);
      i++;
    }
  }

  addMenu() {
    const menuBtnImg = new Button(this, 100, 1260, 'menu', this.displayMenu, 'button-press', 0, 0);
    new DisplaySizeAction(this, menuBtnImg.getButtonImage(), 250, 85, 85).setDelay(3000).run();

   /* const closeButton = new Button(this, 700, 37, 'menuclose', this.closeBtnPressed, 'button-press', 0,0 );
    new DisplaySizeAction(this, closeButton.getButtonImage(), 250, 65, 65).setDelay(3000).run();*/
  }


  closeBtnPressed = () => {
    // @ts-ignore
    if (typeof PblInterface !== 'undefined') {
      // @ts-ignore
      PblInterface.game.exit();
    } else {
      window._po_gm.exit();
    }
  }

  addCallLetters() {
    this.CallTileHorizontalOffset = (this.physics.world.bounds.width - 8*this.CallTileSize - 8*7)/2

    const callTiles = this.revealGameBuilder?.getCallTiles() || [];
    const dropDelays = [200, 400, 150, 300, 0, 250, 100, 350, 50, 450];

    let row = 0;
    for (const tileRow of callTiles) {
      let col = 0;
      for (const tile of tileRow) {
        const targetY = (this.CallTileVerticalOffset + row * this.CallTileSize) + 100;

        const bgSprite = this.add
          .sprite(
            this.CallTileHorizontalOffset + col * this.CallTileSize + 7 * col,
            -10 - (tileRow.length - row) * this.CallTileSize,
            'call-tile-revealed'
          )
          .setDisplaySize(this.CallTileSize , this.CallTileSize )
          .setDepth(0);
        const letterSprite = this.add
          .sprite(
            this.CallTileHorizontalOffset + col * this.CallTileSize,
            -10 - (tileRow.length - row) * this.CallTileSize,
            'letter-' + tile.getSymbol()
          )
          .setDisplaySize(this.CallTileSize, this.CallTileSize)
          .setDepth(0);
        const coverSprite = this.add
          .sprite(
            this.CallTileHorizontalOffset + col * this.CallTileSize,
            -10 - (tileRow.length - row) * this.CallTileSize,
            'call-tile-covered'
          )
          .setDisplaySize(this.CallTileSize, this.CallTileSize)
          .setDepth(0);

        const dropAction = new MoveAction(this, [bgSprite, letterSprite, coverSprite], 1700, bgSprite.x, targetY)
          .setEase('Bounce')
          .setDelay(dropDelays[col]);
        dropAction.setOnComplete(() => {
          bgSprite.setInteractive({ useHandCursor: true });
          bgSprite.on('pointerdown', this.getTileSpriteClickCallback(tile));
        });
        dropAction.run();

        this.callSprites.push(new CrosswordTileSprite(tile, bgSprite, letterSprite, coverSprite));
        col++;
      }
      row++;
    }
  }

  addGridBackground() {
    const gridBackgroundAdjust = -42;
    const gridBackground = this.add
      .sprite(
        this.GridTileHorizontalOffset + this.GridBackgroundSize / 2 + gridBackgroundAdjust,
        this.GridTileVerticalOffset + this.GridBackgroundSize / 2 + gridBackgroundAdjust,
        'grid-background'
      )
      .setDisplaySize(0, 0);

    new DisplaySizeAction(this, gridBackground, 500, this.GridBackgroundSize, this.GridBackgroundSize)
      .setDelay(200)
      .setEase('Power2')
      .run();
  }

  addGridLetters() {
    const gridTiles = this.revealGameBuilder?.getGridTiles() || [];
    const dropDelays = [350, 50, 200, 0, 150, 500, 300, 400, 100, 450, 250];

    let row = 0;
    for (const tileRow of gridTiles[0]) {
      let col = 0;
      for (const tile of tileRow) {
        const targetY = this.GridTileVerticalOffset + row * this.GridTileSize;

        if (tile.isBlank()) {
          const bgSprite = this.add
            .sprite(
              this.GridTileHorizontalOffset + col * this.GridTileSize,
              -100 - (tileRow.length - row) * this.GridTileSize,
              'grid-blank'
            )
            .setDisplaySize(this.GridTileSize + 5, this.GridTileSize + 5)
            .setAlpha(0.8);
          this.gridSprites.push(new CrosswordTileSprite(tile, bgSprite, null, null));
          new MoveAction(this, bgSprite, 1700, bgSprite.x, targetY)
            .setDelay(dropDelays[col])
            .setEase('Bounce')
            .run();
        } else {
          const bgSprite = this.add
            .sprite(
              this.GridTileHorizontalOffset + col * this.GridTileSize,
              -100 - (tileRow.length - row) * this.GridTileSize,
              'grid-covered'
            )
            .setDisplaySize(this.GridTileSize - 3, this.GridTileSize - 3)
            .setDepth(0);
          const letterSprite = this.add
            .sprite(
              this.GridTileHorizontalOffset + col * this.GridTileSize,
              -100 - (tileRow.length - row) * this.GridTileSize,
              'letter-' + tile.getSymbol()
            )
            .setDisplaySize(this.GridTileSize - 3, this.GridTileSize - 3)
            .setDepth(0);

          this.gridSprites.push(new CrosswordTileSprite(tile, bgSprite, letterSprite, null));
          new MoveAction(this, [bgSprite, letterSprite], 1700, bgSprite.x, targetY)
            .setDelay(dropDelays[col])
            .setEase('Bounce')
            .setOnComplete(() => {
              bgSprite.setInteractive({ useHandCursor: true });
              bgSprite.on('pointerdown', this.getTileSpriteClickCallback(tile));
            })
            .run();
        }
        col++;
      }
      row++;
    }
  }

  getTileSpriteClickCallback = (tile: Tile) => () => {
    this.revealGame.attemptToRevealTile(tile);
  };

  addParticles() {
    this.hitScoreParticles = this.add.particles('word-matched-token').setDepth(10);
     this.hitScoreParticles.createEmitter({
      blendMode: 'ADD',
      lifespan: { min: 50, max: 500 },
      speed: 100,
      scale: { start: 0.5, end: 0 },
      on: false
    });
  }

  addEventListeners() {
    // TODO: I think here I need to add the logic for instant win
    this.revealGame.tileRevealed.subscribe(this, (tile: Tile) => {
      const callSprite = this.getCallSpriteFromTile(tile);
      if (callSprite === null) {
        const gridSprite = this.getGridSpriteFromTile(tile);
        if (gridSprite !== null) {
          this.animateGridLetterRevealed(gridSprite, tile);
        }
      } else {
        this.animateCallLetterRevealed(callSprite);
      }

      const instantSpriteList = this.instantWinSprints.filter(
        item => item.getTile().getSymbol() === tile.getSymbol() && tile.isCallTile() && !item.getTile().isRevealed()
      );
      for (const sprite of instantSpriteList) {
        this.animateInstantWinLetterRevealed(sprite, tile);
      }
      this.lettersToFindLabel.setText(this.revealGame.getGridTilesToReveal());
    });

    this.revealGame.tileRevealAttemptBlocked.subscribe(this, (tile: Tile) => {
      const gridSprite = this.getGridSpriteFromTile(tile);
      if (gridSprite !== null && tile.isCovered()) {
        this.animateGridLetterRevealAttemptBlocked(gridSprite);
      }
    });

    this.revealGame.patternRevealed.subscribe(this, (tiles: Tile[]) => {
      this.animateWordRevealed(tiles);
    });

    this.revealGame.instantWinRevealed.subscribe(this, () => {
      this.animateInstantRevealed();

      const yStartPos = 70;
      this.youWonInstantMessage = new CongratsMessageForInstantWin(
        this,
        this.physics.world.bounds.width * 0.8,
        this.physics.world.bounds.height * 0.45,
        [
          {
            text: 'Instant Win Word Revealed',
            fontSize: '45px',
            yPos: yStartPos,
            center: true,
            fontFamily: 'impact',
            styles: { fontWeigth: '600'}
          },
          { text: `YOU WON`, fontSize: '40px', yPos: yStartPos + 90, center: true, fontFamily: 'impact',styles: { fontWeigth: '800'} },
          { text: `${window._po_gm.config.wager / 2 }`, fontSize: '250px', yPos: yStartPos + 240, center: true, fontFamily: 'impact',styles: { fontWeigth: '2000'} },
          { text: `TOKENS`, fontSize: '40px', yPos: yStartPos + 400, center: true, fontFamily: 'impact',styles: { fontWeigth: '800'} }

        ]
      );
    });

    this.revealGame.allTilesRevealed.subscribe(this, () => {
      this.showEndOfGame();
    });
  }

  getSpriteFromTile(tile: Tile, sprites: CrosswordTileSprite[], condition?: (item: CrosswordTileSprite) => boolean) {
    for (const sprite of sprites) {
      const assert = condition ? condition(sprite) : sprite.getTile() === tile;
      if (assert) {
        return sprite;
      }
    }

    return null;
  }

  getCallSpriteFromTile(tile: Tile) {
    return this.getSpriteFromTile(tile, this.callSprites);
  }

  getGridSpriteFromTile(tile: Tile) {
    return this.getSpriteFromTile(tile, this.gridSprites);
  }

  animateCallLetterRevealed(tileSprite: CrosswordTileSprite) {
    const coverSprite = tileSprite.getCoverSprite();
    const backgroundSprite = tileSprite.getBackgroundSprite();
    const letterSprite = tileSprite.getLetterSprite();

    if (!coverSprite) {
      return;
    }

    if (this.hintSequence) {
      this.killHintAnimation();

      backgroundSprite.angle = 0;
      coverSprite.angle = 0;

      const resizeTargets = [backgroundSprite, coverSprite];

      if (letterSprite) {
        letterSprite.angle = 0;
        resizeTargets.push(letterSprite);
      }

      new DisplaySizeAction(this, resizeTargets, 0.3, this.CallTileSize, this.CallTileSize).run();
      for (const target of resizeTargets) {
        if (target) {
          target.setDepth(0);
        }
      }

      this.hintClicked = false;
    }

    tileSprite.getBackgroundSprite().disableInteractive();

    const revealEffect1 = this.add.sprite(coverSprite.x, coverSprite.y, 'call-tile-revealed-effect');
    revealEffect1.setDisplaySize(this.CallTileSize * 1.5, this.CallTileSize * 1.5);
    revealEffect1.setDepth(2);

    const revealEffect2 = this.add.sprite(coverSprite.x, coverSprite.y, 'call-tile-revealed-effect');
    revealEffect2.setDisplaySize(this.CallTileSize * 1.2, this.CallTileSize * 1.2);
    revealEffect2.setAlpha(0.75);
    revealEffect2.setDepth(2);

    new AlphaAction(this, coverSprite, 600, 0)
      .setOnStart(() => {
        if (this.hintClicked) {
          tileSprite.getLetterSprite()?.setDepth(1);
          this.hintClicked = false;
        }
      })
      .run();

    new RotateAction(this, revealEffect1, 1200, 180).run();
    new RotateAction(this, revealEffect2, 1200, -90).run();
    new AlphaAction(this, [revealEffect1, revealEffect2], 600, 0).setDelay(600).run();

    this.audioManager.playSoundEffect('call-tile-revealed');
  }

  animateInstantWinLetterRevealed(tileSprite: CrosswordTileSprite, tile: Tile) {
    const backgroundSprite = tileSprite.getBackgroundSprite();
    const letterSprite = tileSprite.getLetterSprite();

    tileSprite.setBackgroundTexture('grid-revealed');
    tileSprite.setLetterTexture('letter-' + tile.getSymbol());
    tileSprite.getBackgroundSprite().disableInteractive();

    new TweenSequenceAction(
      this,
      new DisplaySizeAction(
        this,
        [backgroundSprite, letterSprite],
        250,
        this.InstantWinTileSize * 1.2,
        this.InstantWinTileSize * 1.2
      ).setEase('Power1'),
      new DisplaySizeAction(this, [backgroundSprite, letterSprite], 125, this.InstantWinTileSize - 5, this.InstantWinTileSize - 5).setEase(
        'Power1'
      ),
      new CallFuncAction(this, () => {
        backgroundSprite.setDepth(0);
        if (letterSprite) {
          letterSprite.setDepth(0);
        }
      })
    ).run();

    this.audioManager.playSoundEffect('grid-tile-revealed');
  }

  animateGridLetterRevealed(tileSprite: CrosswordTileSprite, tile: Tile) {
    const backgroundSprite = tileSprite.getBackgroundSprite();
    const letterSprite = tileSprite.getLetterSprite();

    if (this.hintSequence) {
      this.killHintAnimation();
      this.resetCallTileHintAnimation();

      this.hintClicked = false;
      this.hintTile = null;
    }

    tileSprite.setBackgroundTexture('grid-revealed');
    tileSprite.setLetterTexture('letter-' + tile.getSymbol());
    tileSprite.getBackgroundSprite().disableInteractive();

    backgroundSprite.setDepth(1);
    if (letterSprite) {
      letterSprite.setDepth(1);
    }

    new TweenSequenceAction(
      this,
      new DisplaySizeAction(this, [backgroundSprite, letterSprite], 125, this.GridTileSize * 1.2, this.GridTileSize * 1.2).setEase(
        'Power1'
      ),
      new DisplaySizeAction(this, [backgroundSprite, letterSprite], 125, this.GridTileSize - 3, this.GridTileSize - 3).setEase('Power1'),
      new CallFuncAction(this, () => {
        backgroundSprite.setDepth(0);
        if (letterSprite) {
          letterSprite.setDepth(0);
        }
      })
    ).run();

    this.lettersToFindLabel.setText(this.revealGame.getGridTilesToReveal());

    this.audioManager.playSoundEffect('grid-tile-revealed');
  }

  animateGridLetterRevealAttemptBlocked(tileSprite: CrosswordTileSprite) {
    if (this.isGridSpriteCurrentlyAnimatingBlockedReveal(tileSprite)) {
      return;
    }

    if (tileSprite) {
      this.gridSpritesCurrentlyAnimatingBlockedReveal.push(tileSprite);
    }

    const backgroundSprite = tileSprite.getBackgroundSprite();
    const letterSprite = tileSprite.getLetterSprite();

    const initialBackgroundX = backgroundSprite.x;
    const initialBackgroundY = backgroundSprite.y;

    let self = this;

    const letterRevealBlockedSequence = new TweenSequenceAction(
      this,
      new MoveAction(this, [backgroundSprite, letterSprite], 25, initialBackgroundX - 5, initialBackgroundY).setDepth(1),
      new MoveAction(this, [backgroundSprite, letterSprite], 50, initialBackgroundX + 5, initialBackgroundY),
      new MoveAction(this, [backgroundSprite, letterSprite], 25, initialBackgroundX, initialBackgroundY)
    ).setLoop(2);

    letterRevealBlockedSequence.setOnComplete(() => {
      backgroundSprite.setDepth(0);
      if (letterSprite !== null) {
        letterSprite.setDepth(0);
      }
      self.gridSpritesCurrentlyAnimatingBlockedReveal.splice(this.gridSpritesCurrentlyAnimatingBlockedReveal.indexOf(tileSprite), 1);
    });

    letterRevealBlockedSequence.run();

    this.audioManager.playSoundEffect('grid-tile-reveal-blocked');
  }

  animateInstantRevealed() {
    const gridSprites = this.instantWinSprints;
    let delay = 200;
    const self = this;

    for (const gridSprite of gridSprites) {
      if (this.isGridSpriteCurrentlyAnimatingWordReveal(gridSprite)) {
        continue;
      }

      this.gridSpritesCurrentlyAnimatingWordReveal.push(gridSprite);

      const backgroundSprite = gridSprite.getBackgroundSprite();
      const letterSprite = gridSprite.getLetterSprite();
      new TileJumpAction(
        this,
        [backgroundSprite, letterSprite],
        500,
        gridSprite.getBackgroundSprite().x,
        gridSprite.getBackgroundSprite().y,
        backgroundSprite.scaleX + 0.2,
        backgroundSprite.scaleX + 0.2
      )
        .setDelay(delay)
        .setEase('Power2')
        .setYoyo(true)
        .setDepth(2)
        .run();

      this.time.addEvent({
        delay: delay,
        callback: self.getWordRevealedFrameChangeCallback(backgroundSprite)
      });
    }

    this.time.addEvent({
      delay: delay + 2000,
      callback: function() {
        self.gridSpritesCurrentlyAnimatingWordReveal = [];
      }
    });

    this.time.addEvent({
      delay: 300,
      callback: function() {
        self.audioManager.playSoundEffect('instant-word-win');
      }
    });
  }

  animateWordRevealed(tiles: Tile[]) {
    const gridSprites: CrosswordTileSprite[] = [];

    for (const tile of tiles) {
      const gridSprite = this.getGridSpriteFromTile(tile);
      if (gridSprite !== null) {
        gridSprites.push(gridSprite);
      }
    }
    let delay = 200;
    const self = this;
    for (const gridSprite of gridSprites) {
      if (this.isGridSpriteCurrentlyAnimatingWordReveal(gridSprite) ) {
        continue;
      }

      this.gridSpritesCurrentlyAnimatingWordReveal.push(gridSprite);

      const backgroundSprite = gridSprite.getBackgroundSprite();
      const letterSprite = gridSprite.getLetterSprite();
      delay += 100;

      new TileJumpAction(
        this,
        [backgroundSprite, letterSprite],
        500,
        gridSprite.getBackgroundSprite().x,
        gridSprite.getBackgroundSprite().y - 115,
        backgroundSprite.scaleX * 1.2,
        backgroundSprite.scaleX * 1.2
      )
        .setDelay(delay)
        .setEase('Power2')
        .setYoyo(true)
        .setDepth(2)
        .run();

      this.time.addEvent({
        delay: delay,
        callback: self.getWordRevealedFrameChangeCallback(backgroundSprite)
      });
    }

    this.time.addEvent({
      delay: delay + 500,
      callback: function() {
        self.gridSpritesCurrentlyAnimatingWordReveal = [];
      }
    });

    this.time.addEvent({
      delay: delay + 1000,
      callback: function() {
        self.animateWordsMatchedUpdated(gridSprites);
      }
    });

    this.time.addEvent({
      delay: 300,
      callback: function() {
        self.audioManager.playSoundEffect('grid-tile-word-matched');
      }
    });
  }

  isGridSpriteCurrentlyAnimatingWordReveal(gridSprite: CrosswordTileSprite) {
    return this.gridSpritesCurrentlyAnimatingWordReveal.indexOf(gridSprite) >= 0;
  }

  isGridSpriteCurrentlyAnimatingBlockedReveal(gridSprite: CrosswordTileSprite) {
    return this.gridSpritesCurrentlyAnimatingBlockedReveal.indexOf(gridSprite) >= 0;
  }

  getWordRevealedFrameChangeCallback(backgroundSprite: Phaser.GameObjects.Sprite) {
    return function() {
      backgroundSprite.setTexture('grid-matched');
    };
  }

  animateWordsMatchedUpdated(gridSprites: CrosswordTileSprite[]) {
    const wordCenterPoint = this.getCenterPointOfWord(gridSprites);
    const wordMatchToken = this.add
      .sprite(wordCenterPoint.x, wordCenterPoint.y, 'word-matched-token')
      .setDisplaySize(50, 50)
      .setDepth(1);
    const duration =
      Phaser.Math.Distance.Between(wordCenterPoint.x, wordCenterPoint.y, this.wordsMatchedLabel.x, this.wordsMatchedLabel.y) * 2.5;

    new MoveAction(this, wordMatchToken, duration, this.wordsMatchedLabel.x, this.wordsMatchedLabel.y)
      .setEase('Power2')
      .setOnComplete(() => {
        this.children.remove(wordMatchToken);
        this.updateWordsMatched();
      })
      .run();
  }

  getCenterPointOfWord(gridSprites: CrosswordTileSprite[]) {
    let minX = 99999;
    let minY = 99999;
    let maxX = 0;
    let maxY = 0;

    for (const gridSprite of gridSprites) {
      minX = Math.min(minX, gridSprite.getBackgroundSprite().x);
      minY = Math.min(minY, gridSprite.getBackgroundSprite().y);
      maxX = Math.max(maxX, gridSprite.getBackgroundSprite().x);
      maxY = Math.max(maxY, gridSprite.getBackgroundSprite().y);
    }

    let targetX = Phaser.Math.Average([minX, maxX]);
    let targetY = Phaser.Math.Average([minY, maxY]);

    return {
      x: targetX,
      y: targetY
    };
  }

  updateWordsMatched() {
    this.hitScoreParticles.emitParticleAt(260, 440, 1);
    this.wordsMatchedLabel.setText(parseInt(this.wordsMatchedLabel.text) + 1);
  }

  displayMenu = () => {
    console.warn('Open menu', this);
    new MenuComponent(this, this.physics.world.bounds.width, this.physics.world.bounds.height, this.revealGame, this.audioManager);
  };

  showEndOfGame() {
    this.time.addEvent({
      delay: 5000,
      callback: () => {
        const isForPrizes = this.isPlayForPrizes();
        if (this.getPrizeAmount() === '0') {
          this.winningMessage = new GameOverMessage(
            this,
            this.physics.world.bounds.width,
            this.physics.world.bounds.height,
            isForPrizes
          );
        } else if (isForPrizes) {
          this.winningMessage = new CongratsMessageForPrizes(
            this,
            this.physics.world.bounds.width,
            this.physics.world.bounds.height,
            this.getPrizeAmount()
          );
        } else {
          this.winningMessage = new CongratsMessageForFun(
            this,
            this.physics.world.bounds.width,
            this.physics.world.bounds.height,
          );
        }

        this.audioManager.playSoundEffect('end-of-game');

      }
    });
    //@ts-ignore
    if (typeof PblInterface !== 'undefined') {
      // @ts-ignore
      PblInterface.game.update(this.isAutoRevealing);
    }
  }

  getPrizeAmount() {

    let winType;
    // @ts-ignore
    if (typeof PblInterface !== 'undefined') {
      // @ts-ignore
     winType =  PblInterface.game.config.winType;
    } else {
     winType = window._po_gm.config.winType
    }
    switch (winType) {
      case '07': return '$5000';
      case '06': return '$500';
      case '05': return '$25';
      case '04': return '$10';
      case '03': return '$6';
      case '02': return 'Free $5 Crossword Ticket';
      case '01': return '$3';
      case '00': return '0';
    }
  }

  getEntryCode() {
    // @ts-ignore
    if (typeof PblInterface !== 'undefined') {
      // @ts-ignore
      return PblInterface.game.config.messages.eog_code;
    } else {
      return window._po_gm.config.messages.eog_code;
    }
  }
  isPlayForPrizes() {
    // @ts-ignore
    if (typeof PblInterface !== 'undefined') {
      // @ts-ignore
      return PblInterface.game.config.gameType !== 'fun';
    } else {
      return window._po_gm.config.gameType !== 'fun';
    }
  }

  addHintButton() {

    const hintButton = new Button(
      this,
      325,
      this.physics.world.bounds.height - 70,
      'hint',
      () => {
        if (this.isAutoRevealing || this.hintClicked) {
          return;
        }

        this.hintClicked = true;
        this.hintTile = this.revealGame.getNextAvailableTile();
        const hintSprite = this.hintTile.isCallTile()
          ? this.getCallSpriteFromTile(this.hintTile)
          : this.getGridSpriteFromTile(this.hintTile);

        this.animateTileHint(hintSprite);

        this.audioManager.playSoundEffect('hint');
      },
      '',
      234,
      66
    );

    const targetScale = hintButton.getButtonImage().scaleX;
    hintButton.getButtonImage().setDisplaySize(0, 0);
    new ScaleAction(this, hintButton.getButtonImage(), 250, targetScale, targetScale).setDelay(3100).run();
  }

  animateTileHint(tileSprite: CrosswordTileSprite | null) {
    const hintAnimation = this.getHintAnimation();

    const backgroundSprite = tileSprite?.getBackgroundSprite();
    const currentScale = backgroundSprite?.scale || 0;

    this.hintSprite = this.add
      .sprite(backgroundSprite?.x || 0, backgroundSprite?.y || 0, 'hint-1')
      .setDisplaySize(this.GridTileSize + 30, this.GridTileSize + 30)
      .setDepth(1);

    const targets = [backgroundSprite, tileSprite?.getLetterSprite()];
    const coverSprite = tileSprite?.getCoverSprite();

    if (typeof coverSprite !== 'undefined') {
      targets.push(coverSprite);
    }

    targets.push(this.hintSprite);

    this.hintSprite.anims.play(hintAnimation, true);

    this.hintSequence = new TweenSequenceAction(
      this,
      new ScaleAction(this, targets, 300, currentScale * 1.4, currentScale * 1.4).setDepth(1),
      new RotateAction(this, targets, 300, 30),
      new RotateAction(this, targets, 300, -30),
      new RotateAction(this, targets, 300, 0).setDepth(undefined),
      new ScaleAction(this, targets, 300, currentScale, currentScale).setOffset('-=300'),
      new TweenAction(this, targets, 100).setDelay(200).setOnComplete(() => {
        this.hintSprite.destroy();
        this.hintSprite = null;

        if (this.hintSequence) {
          this.hintSequence.destroy();
          this.hintSequence = null;
        }

        this.hintClicked = false;
        this.hintTile = null;
        for (const target of targets) {
          if (target) {
            target.setDepth(0);
          }
        }
      })
    );
    this.hintSequence.run();
  }

  getHintAnimation() {
    const key = 'hint';

    this.anims.create({
      key,
      frameRate: 16,
      repeat: 16,
      frames: [{ key: 'hint-1' }, { key: 'hint-2' }, { key: 'hint-3' }, { key: 'hint-4' }]
    });

    return key;
  }

  addRevealAllButton() {
    this.revealAllButton = new Button(
      this,
      600,
      this.physics.world.bounds.height - 70,
      'reveal',
      () => {
        if (!this.isAutoRevealing) {
          this.autoRevealNextCallTile();
        }
      },
      'button-press',
      234,
      66
    );

    const targetScale = this.revealAllButton.getButtonImage().scaleX;
    this.revealAllButton.getButtonImage().setDisplaySize(0, 0);

    new ScaleAction(this, this.revealAllButton.getButtonImage(), 250, targetScale, targetScale).setDelay(3150).run();
  }

  autoRevealNextCallTile() {
    this.isAutoRevealing = true;
    const nextCallTile = this.revealGame.getNextAvailableCallTile();

    if (nextCallTile.isBlank()) {
      this.time.addEvent({
        delay: 250,
        callback: () => {
          this.autoRevealNextGridTile();
        }
      });
    } else {
      this.revealGame.attemptToRevealTile(nextCallTile);
      this.time.addEvent({
        delay: 250,
        callback: () => {
          this.autoRevealNextCallTile();
        }
      });
    }
  }

  autoRevealNextGridTile() {
    const nextGridTile = this.revealGame.getNextAvailableGridTile();

    if (!nextGridTile.isBlank()) {
      this.revealGame.attemptToRevealTile(nextGridTile);
      this.time.addEvent({
        delay: 250,
        callback: () => {
          this.autoRevealNextGridTile();
        }
      });
    }
  }

  private killHintAnimation() {
    this.hintSprite.destroy();
    this.hintSprite = null;
    if (this.hintSequence) {
      this.hintSequence.stop();
      this.hintSequence.destroy();
      this.hintSequence = null;
    }
  }

  private resetCallTileHintAnimation() {
    if (!this.hintTile) {
      return;
    }

    let tileToReset;
    let resetSize;

    if (this.hintTile.isCallTile()) {
      tileToReset = this.getCallSpriteFromTile(this.hintTile);
      resetSize = this.CallTileSize;
    } else {
      tileToReset = this.getGridSpriteFromTile(this.hintTile);
      resetSize = this.GridTileSize;
    }

    if (tileToReset) {
      const spritesToReset = [tileToReset.getBackgroundSprite(), tileToReset.getLetterSprite(), tileToReset.getCoverSprite()];
      for (const sprite of spritesToReset) {
        if (sprite) {
          sprite.angle = 0;
          sprite.setDisplaySize(resetSize, resetSize);
        }
      }
    }
  }

  private addFunGameLabel() {
    this.add.image(375, 1185, 'fun-mode');
  }
}
